import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Roles } from '../models/roles';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor( private authService: AuthService, private router: Router) {}
  public async canActivate( route: ActivatedRouteSnapshot): Promise<boolean>  {
    const rolesPermitidos = this.getRoutePermissions(route);
    return await this.validarPermisos(rolesPermitidos);
  }

  private getRoutePermissions(route: ActivatedRouteSnapshot): Roles[] {
    if (route.data && route.data.rolesUsuario) {
      return route.data.rolesUsuario as Roles[];
    }
    return null;
  }

  private async validarPermisos( rolesPermitidos: Roles[]){
    const estaLogeado = await this.authService.isLogedIn();
    if(estaLogeado){
      if (!rolesPermitidos) {
        return true; //si no se entrega ningun rol, entonces todos tienen acceso a ese componente
      } else{
        let rolesUsuarioActual = [...JSON.parse(localStorage.getItem('usuario')).usuario.perfiles];
        const tienePermisos = await this.authService.esRolPermitido(rolesUsuarioActual, rolesPermitidos);
        if(tienePermisos){
          return true;
        } else{
          this.router.navigate(['/auth']);
          return false;
        }
      }
    } else{
      this.router.navigate(['/auth']);
      return false;
    }
  }
  
}
